import './assets/main.css'
import 'primeicons/primeicons.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import { createApp } from 'vue';
import App from './App.vue';

import { createPinia } from 'pinia'
import { DialogService } from 'primevue'
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
 
import router from './router';
import { createGtag } from 'vue-gtag';
import Image from 'primevue/image'
import Tooltip from 'primevue/tooltip';

const gtag = createGtag({
    tagId: 'G-H7TC6N4HCH'
});

const app = createApp(App)

app.use(createPinia())

app.use(PrimeVue, {
  theme: 'none'
})
app.directive('tooltip', Tooltip);

app.use(ToastService)
app.use(DialogService)
app.use(ConfirmationService);
app.use(gtag);
app.component('Image', Image)

app.use(router)

app.mount('#app')
